function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.08,14.7575 C13.08,14.7575 12.83,15.3825 12.1425,15.0825 L9.60125,13.13375 L7.97125,14.62125 C7.97125,14.62125 7.84375,14.7175 7.705,14.6575 L8.0175,11.89625 L8.0275,11.905 L8.03375,11.8475 C8.03375,11.8475 12.605,7.73875 12.7925,7.56375 C12.98,7.38875 12.9175,7.35125 12.9175,7.35125 C12.93,7.13875 12.58,7.35125 12.58,7.35125 L6.5225,11.1975 L4,10.35 C4,10.35 3.6125,10.21125 3.575,9.9125 C3.5375,9.6125 4.0125,9.45 4.0125,9.45 L14.0425,5.515 C14.0425,5.515 14.86625,5.1525 14.86625,5.7525 L13.08,14.7575 Z M10,0 C4.4775,0 0,4.4775 0,10 C0,15.5225 4.4775,20 10,20 C15.52375,20 20,15.5225 20,10 C20,4.4775 15.52375,0 10,0 Z",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/telegram.1cfadf24.svg";
export { SvgComponent as ReactComponent };